import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { TAGOutlinedButton, TAGTypography, TAGPhoneDrawer, Box, Grid, useTheme, useMediaQuery, TAGDialog, TAGDialogActions, TAGDialogContent, TAGDialogTitle } from '../../../';
import TAGMeatballMenu from '../../elements/TAGSteppers/TAGMeatballMenu';
import BackArrow from './BackArrow';
import ForwardArrow from './ForwardArrow';

var SwipableContent = function SwipableContent(_ref) {
  var bodyVariant = _ref.bodyVariant,
      _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps,
      SWIPABLE_PROPS = _ref.SWIPABLE_PROPS,
      titleVariant = _ref.titleVariant,
      activeStep = _ref.activeStep,
      handleStep = _ref.handleStep;
  var theme = useTheme();
  var isMobileDevice = useMediaQuery('(max-width:768px)');
  var isSmallScreen = useMediaQuery(theme.breakpoints.down(600));
  var mobileSwitch = isMobileDevice ? {
    bodyFontSize: '16px',
    bodyMarginTop: '',
    lineHeight: '24px',
    dialogContainerHeight: '430px',
    dialogContentHeight: '330px'
  } : {
    bodyFontSize: '18px',
    bodyMarginTop: '60px',
    lineHeight: '28px',
    dialogContainerHeight: '380px',
    dialogContentHeight: '300px'
  };
  return React.createElement(React.Fragment, null, React.createElement(SwipeableViews, _objectSpread(_objectSpread({
    id: "swipeable"
  }, SWIPABLE_PROPS), {}, {
    containerStyle: {
      height: mobileSwitch.dialogContainerHeight
    },
    slideStyle: {
      overflow: 'hidden'
    }
  }), steps.map(function (content) {
    return React.createElement(React.Fragment, null, React.createElement(TAGDialogTitle, {
      variant: titleVariant,
      sx: {
        width: '95%',
        backgroundColor: 'backgrounds.white',
        paddingLeft: isSmallScreen ? '12px' : ''
      }
    }, content.headlineText), React.createElement(TAGDialogContent, {
      variant: bodyVariant,
      sx: {
        position: 'relative',
        maxHeight: mobileSwitch.dialogContentHeight,
        overflow: 'auto',
        '::-webkit-scrollbar': {
          display: 'none'
        },
        padding: '0px',
        marginTop: '-15px',
        '.MuiTypography-root': {
          fontSize: mobileSwitch.bodyFontSize,
          lineHeight: mobileSwitch.lineHeight
        }
      }
    }, content.bodyText));
  })), steps.length > 1 && React.createElement(TAGMeatballMenu, {
    steps: steps,
    activeStep: activeStep,
    handleStep: handleStep,
    sx: {
      marginBottom: '15px'
    }
  }));
};

var Modal = function Modal(_ref2) {
  var arrows = _ref2.arrows,
      closeButton = _ref2.closeButton,
      _ref2$currentStep = _ref2.currentStep,
      currentStep = _ref2$currentStep === void 0 ? 0 : _ref2$currentStep,
      _ref2$bodyVariant = _ref2.bodyVariant,
      bodyVariant = _ref2$bodyVariant === void 0 ? 'bodyLargeBook' : _ref2$bodyVariant,
      darkScrim = _ref2.darkScrim,
      _ref2$maxWidth = _ref2.maxWidth,
      maxWidth = _ref2$maxWidth === void 0 ? 'md' : _ref2$maxWidth,
      _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? false : _ref2$open,
      _ref2$steps = _ref2.steps,
      steps = _ref2$steps === void 0 ? [] : _ref2$steps,
      sx = _ref2.sx,
      _ref2$titleVariant = _ref2.titleVariant,
      titleVariant = _ref2$titleVariant === void 0 ? 'h2' : _ref2$titleVariant,
      onClose = _ref2.onClose,
      onOpen = _ref2.onOpen;
  var theme = useTheme();
  var isMobileDevice = useMediaQuery('(max-width:768px)');

  var _useState = useState(currentStep),
      _useState2 = _slicedToArray(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  useEffect(function () {
    setActiveStep(currentStep);
  }, [currentStep]);

  var handleStep = function handleStep(step) {
    if (activeStep === step) {
      return null;
    }

    setActiveStep(step);
  };

  var handleSwipeChange = function handleSwipeChange(step) {
    setActiveStep(step);
  };

  var handleNext = function handleNext() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
  };

  var handleBack = function handleBack() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
  };

  var LeftIndicator = function LeftIndicator() {
    return activeStep === 0 ? null : React.createElement(BackArrow, {
      handleBack: handleBack
    });
  };

  var RightIndicator = function RightIndicator() {
    return activeStep === steps.length - 1 ? null : React.createElement(ForwardArrow, {
      handleNext: handleNext
    });
  };

  var DialogActions = function DialogActions() {
    /* NOTE: Something that can be expanded on is creating an else if condition that recieves a button group case
      where the buttons can perform other actions besides next/previous or close
           For example: If developer wants to include an apply/dismiss button group
    */
    if (closeButton) {
      return React.createElement(Box, {
        display: "flex",
        justifyContent: "flex-end",
        sx: {
          width: '100%'
        }
      }, React.createElement(TAGOutlinedButton, {
        buttonSize: "small",
        buttonTheme: "OUTLINEDANDTEXTBLUE",
        onClick: onClose
      }, React.createElement(TAGTypography, {
        variant: "buttonLarge"
      }, closeButton)));
    }

    return React.createElement(Box, {
      display: "flex",
      justifyContent: activeStep === 0 ? 'flex-end' : 'space-between',
      sx: {
        width: '100%'
      }
    }, activeStep === 0 ? null : React.createElement(Box, null, React.createElement(TAGOutlinedButton, {
      buttonSize: "small",
      buttonTheme: "OUTLINEDANDTEXTBLUE",
      onClick: function onClick() {
        return handleBack();
      }
    }, React.createElement(TAGTypography, {
      variant: "buttonLarge"
    }, "Previous"))), activeStep === steps.length - 1 ? null : React.createElement(Box, null, React.createElement(TAGOutlinedButton, {
      buttonSize: "small",
      buttonTheme: "OUTLINEDANDTEXTBLUE",
      onClick: function onClick() {
        return handleNext();
      }
    }, React.createElement(TAGTypography, {
      variant: "buttonLarge"
    }, "Next"))));
  };

  var SWIPABLE_PROPS = {
    axis: theme.direction === 'rtl' ? 'x-reverse' : 'x',
    index: activeStep,
    onChangeIndex: handleSwipeChange,
    enableMouseEvents: true
  };
  var swipableContentProps = {
    steps: steps,
    titleVariant: titleVariant,
    bodyVariant: bodyVariant,
    SWIPABLE_PROPS: SWIPABLE_PROPS,
    handleStep: handleStep,
    activeStep: activeStep
  };

  if (!isMobileDevice) {
    return React.createElement(React.Fragment, null, React.createElement(TAGDialog, {
      open: open,
      maxWidth: maxWidth,
      handleClose: onClose,
      showCloseIcon: true,
      darkScrim: darkScrim,
      sx: sx
    }, React.createElement(SwipableContent, _objectSpread({}, swipableContentProps)), steps.length > 1 && React.createElement(TAGDialogActions, null, React.createElement(DialogActions, null))));
  }

  return React.createElement(React.Fragment, null, React.createElement(TAGPhoneDrawer, {
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    sx: sx
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, arrows && React.createElement(Grid, {
    item: true,
    xs: 1,
    display: "flex",
    justifyContent: "flex-end"
  }, React.createElement(LeftIndicator, null)), React.createElement(Grid, {
    item: true,
    xs: arrows ? 10 : 12,
    sx: {
      '#swipeable > .react-swipeable-view-container > div ': {
        '::-webkit-scrollbar': {
          display: 'none'
        }
      }
    }
  }, React.createElement(SwipableContent, _objectSpread({}, swipableContentProps))), arrows && React.createElement(Grid, {
    item: true,
    xs: 1,
    display: "flex",
    justifyContent: "flex-start"
  }, React.createElement(RightIndicator, null)))));
};

export default Modal;